(function () {
  const setExpanded = (item, expanded, animate = true) => {
    const button = item.querySelector('.collapsible-content__toggle');
    const panel = item.querySelector('.collapsible-content__answer');
    if (!button || !panel) return;

    const answer = $(panel);
    answer.stop(true, true);
    button.setAttribute('aria-expanded', String(expanded));
    item.classList.toggle('active', expanded);
    panel.inert = !expanded;
    const duration = animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 200 : 0;

    if (!duration) {
      panel.hidden = !expanded;
      answer.css('display', '');
    } else if (expanded) {
      panel.hidden = false;
      answer.hide().slideDown(duration, () => answer.css('display', ''));
    } else {
      answer.slideUp(duration, () => {
        panel.hidden = true;
        answer.css('display', '');
      });
    }
  };

  const initCollapsibleContent = (root = document) => {
    $(root).find('.collapsible-content__items').each(function () {
      const list = this;
      const items = [...list.children].filter(item => item.matches('.collapsible-content__item'));
      const buttons = items.map(item => item.querySelector('.collapsible-content__toggle')).filter(Boolean);
      items.forEach(item => setExpanded(item, item.classList.contains('active'), false));

      $(list).off('.bsAccordion').on('click.bsAccordion', '.collapsible-content__toggle', function () {
        const selected = this.closest('.collapsible-content__item');
        const expanded = this.getAttribute('aria-expanded') !== 'true';
        items.forEach(item => {
          if (item !== selected && item.classList.contains('active')) setExpanded(item, false);
        });
        setExpanded(selected, expanded);
      }).on('keydown.bsAccordion', function (event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        const item = event.target.closest('.collapsible-content__item');
        if (!item || !list.contains(item)) return;
        const button = item.querySelector('.collapsible-content__toggle');

        if (event.key === 'Escape' && button?.getAttribute('aria-expanded') === 'true') {
          event.preventDefault();
          event.stopPropagation();
          setExpanded(item, false);
          button.focus();
          return;
        }

        if (event.target !== button) return;
        const position = buttons.indexOf(button);
        let next;
        if (event.key === 'ArrowDown') next = (position + 1) % buttons.length;
        else if (event.key === 'ArrowUp') next = (position - 1 + buttons.length) % buttons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = buttons.length - 1;
        if (next !== undefined) {
          event.preventDefault();
          buttons[next].focus();
        }
      });
    });
  };

  $(document).off('shopify:section:load.bsAccordion').on('shopify:section:load.bsAccordion', event => {
    initCollapsibleContent(event.target);
  });
  $(document).off('shopify:block:select.bsAccordion').on('shopify:block:select.bsAccordion', event => {
    const item = event.target.closest('.collapsible-content__item');
    if (item) setExpanded(item, true, false);
  });
  initCollapsibleContent();
})();
